import Vue from 'vue'
import EntryMutations from './mutations-types'

export default {
  [EntryMutations.SET_ENTRIES](state, list) {
    state.breadcrumb = [...list.breadcrumb ?? state.breadcrumb]
    state.entries = [...list.entries ?? []]
  },

  [EntryMutations.ADD_ENTRY](state, nodeData) {
    state.entries = [...state.entries, nodeData]
  },

  [EntryMutations.UPDATE_ENTRY](state, {nodeId, params}) {
    const index = state.entries.findIndex(e => e.node_id == nodeId)

    if (false === index || index < 0) {
      return
    }

    const updatedObj = {...state.entries[index], ...params}

    Vue.set(state.entries, index, updatedObj)
  },

  [EntryMutations.UPSERT_ENTRY](state, {nodeId, params}) {
    const index = state.entries.findIndex(e => e.node_id == nodeId)

    if (false === index || index < 0) {

      state.entries = [...state.entries, params]

      return
    }

    const updatedObj = {...state.entries[index], ...params}

    Vue.set(state.entries, index, updatedObj)
  },

  [EntryMutations.REMOVE_ENTRY](state, nodeId) {
    const index = state.entries.findIndex(e => e.node_id == nodeId)

    if (index !== -1) {
      state.entries.splice(index, 1)
    }
  },
}
